import React from 'react';
import './button.scss';
import Spinner from '../Spinner';

const Button = ({
  children,
  color = 'blue',
  className = '',
  size = 'sm',
  style = {},
  loading,
  disabled,
  ...rest
}) => {
  const classNames = [
    'custom-btn',
    size,
    color,
    loading ? 'loading' : '',
    className,
  ]
    .join(' ')
    .trim();
  return (
    <button
      {...rest}
      className={classNames}
      style={style}
      disabled={loading || disabled}
    >
      {loading ? <Spinner /> : children}
    </button>
  );
};

export default Button;
